<script lang="ts" setup>
import { useOnboardingExit } from '~/composables/use-onboarding-exit';

const { covering } = useOnboardingExit();
</script>

<template>
	<div
		class="fixed inset-0 z-100001"
		:class="covering ? '' : 'pointer-events-none'"
		aria-hidden="true"
	>
		<div
			class="absolute inset-0 transition-[backdrop-filter] ease-out motion-reduce:transition-none"
			:class="covering ? 'backdrop-blur-sm duration-slow' : 'backdrop-blur-none duration-slow'"
		/>
		<div
			class="absolute inset-0 bg-muted transition-opacity ease-out motion-reduce:transition-none"
			:class="covering ? 'opacity-100 duration-slow' : 'opacity-0 duration-slow'"
		/>
	</div>
</template>
